import { ICotizacion } from '../models/icotizacion';
import { ROUTE_COMERCIAL } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MaterialEstandarService {


    constructor(private apiService: ApiService) { }

    insertarMatEstandar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudMaterialesEstandar);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarMatEstandar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudMaterialesEstandar);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarMatEstandar(tipinvpro: any,codartpro: any,codclase: any,codadd01pro: any,codadd02pro: any,tipinvstd: any,codartstd: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudMaterialesEstandar+'/v2');
        return this.apiService.executeDeleteJson(`?tipinvpro=${tipinvpro}&codartpro=${codartpro}&codclase=${codclase}&codadd01pro=${codadd01pro}&codadd02pro=${codadd02pro}&tipinvstd=${tipinvstd}&codartstd=${codartstd}`).pipe();
    }

    obtenerMatEstandar(tipinvpro: any,codartpro: any,codclase: any,codadd01pro: any,codadd02pro: any,item: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudMaterialesEstandar+'/obtener');
        return this.apiService.execGetQueryJson(`?tipinvpro=${tipinvpro}&codartpro=${codartpro}&codclase=${codclase}&codadd01pro=${codadd01pro}&codadd02pro=${codadd02pro}&item=${item}`).pipe();
    }

    buscarMatEstandar(tipinvpro: any,codartpro: any,codclase: any,codadd01pro: any,codadd02pro: any,item: any,tipinvstd: any,codartstd: any,etapa: any,swacti: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.buscarMEstandar);
        return this.apiService.execGetQueryJson(`?tipinvpro=${tipinvpro}&codartpro=${encodeURIComponent(codartpro)}&codclase=${codclase}&codadd01pro=${codadd01pro}&codadd02pro=${codadd02pro}&item=${item}&tipinvstd=${tipinvstd}&codartstd=${codartstd}&etapa=${etapa}&swacti=${swacti}`).pipe();
    }
    
}